<template>
  <div class="bc item">
    <div :class="[ landscape ? 'top' : 'top-portrait']">
      <div class="lf">
        <img class="logo" src="../../assets/bc/logo.png" v-animate-css="logoIn" alt="">
        <img class="text" src="../../assets/bc/text.png" v-animate-css="textIn" alt="">
        <img class="bg" src="../../assets/bc/bg.png" v-animate-css="bgIn" alt="">
      </div>
      <div class="rt">
        <img class="en" src="../../assets/bc/en.png" alt="" v-animate-css="detailTextIn">
        <div class="line" v-animate-css="lineIn"></div>
        <p v-animate-css="detailText1In">区块链技术经过近年持续发展，出现了非常优秀的去中心化案例，在金融、物流、法律、科技等行都提供了信任传递、合约执行、数字存证、新金融工具等各种解决方案。各个行业也积极的探索区块链在传统行业的落地方案。</p>
        <p v-animate-css="detailText2In">我们基于近几年在区块链行业的学习和研究，在区块链底层技术、Token 发行合约设计、数字货币交易所核心系统开发、区块链在 AI 行业落地等方向积累了较多经验。我们将继续在区块链行业探索，为区块链在 AI 等其他行业的落地提供一份力量。</p>
      </div>
    </div>
    <div class="paging">
      <div class="btn-left" @mouseover="showArrow('left')" @mouseout="hideArrow('left')" @click="slide(-1)"></div>
      <div class="btn-right" @mouseover="showArrow('right')" @mouseout="hideArrow('right')" @click="slide(1)"></div>
      <div class="paging-left" v-if="left"></div>
      <div class="paging-right" v-if="right"></div>
      <div class="page-num">2/3</div>
    </div>
    <div class="close" @click="routeTo('Dashboard')">
      <div class="btn-close"></div>
      <span>close</span>
    </div>
  </div>
</template>

<script>
import Config from './Config.js'
export default {
  mixins: [
    Config
  ]
}
</script>

<style lang="scss" scoped>
@import '../../Global.scss';
@import './Detail.scss';
.logo {
  width: 2.89rem;
  height: 1.52rem;
  left: .3rem;
  top: 2.05rem;
}
.bg {
  width: 4.35rem;
  height: 4.63rem;
  left: 1rem;
}
.text {
  width: 1.825rem;
  height: 2.43rem;
  top: 1.55rem;
  left: 2.3rem;
}
.en {
  width: .885rem;
  height: .14rem;
  display: block;
}
.paging {
  background-image: url('../../assets/bc/paging.png');
  .btn-left {
    width: 1.2rem;
  }
  .btn-right {
    width: 1.1rem;
  }
  .page-num {
    left: 1.25rem;
  }
  .paging-left {
    background-image: url('../../assets/bc/paging_l.png');
  }
  .paging-right {
    background-image: url('../../assets/bc/paging_r.png');
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Detail/Part2.vue